import { Info } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { useRef, useState } from 'react';
import { FlexAlignmentY } from "../../helper/Layout.js";
import { IconButton } from "../iconButton/IconButton.js";
import { Tooltip } from "../tooltip/Tooltip.js";
import styles from "./InfoTooltip.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InfoTooltip = ({
  content,
  children,
  className,
  title,
  inline,
  zIndex,
  appendTo,
  alignmentY = FlexAlignmentY.INHERIT,
  onOpen,
  icon = Info,
  type,
  offsetX = -132
}) => {
  const [open, setOpen] = useState(false);
  const classes = classnames(styles.infoTooltip, className, {
    [styles.empty]: !content && !title,
    [styles.inline]: inline
  });
  const buttonClasses = classnames(styles.infoButton, styles[alignmentY]);
  const handleIconClick = () => {
    if (!open && onOpen) {
      onOpen();
    }
    setOpen(!open);
  };
  const handleCloseClick = () => {
    setOpen(false);
  };
  const iconRef = useRef(null);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.children,
      children: children
    }), content && /*#__PURE__*/_jsx(Tooltip, {
      content: content,
      title: title,
      placement: "bottom",
      fallbackPlacements: ['right', 'top', 'left'],
      zIndex: zIndex,
      open: open,
      onCloseClick: handleCloseClick,
      onClickOutside: handleCloseClick,
      iconRef: iconRef,
      offsetX: offsetX,
      appendTo: appendTo,
      type: type,
      children: /*#__PURE__*/_jsx("span", {
        className: buttonClasses,
        ref: iconRef,
        children: /*#__PURE__*/_jsx(IconButton, {
          icon: icon,
          onClick: handleIconClick,
          toolbar: true
        })
      })
    })]
  });
};

/**
 * @deprecated This type has been renamed to InfoTooltipProps
 */

/**
 * @deprecated This component has been renamed to InfoTooltip
 */
export const HelpTooltip = InfoTooltip;